import { render, staticRenderFns } from "./subscribe-admin.vue?vue&type=template&id=c5462acc"
import script from "./subscribe-admin.vue?vue&type=script&lang=js"
export * from "./subscribe-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports